import { toDateTime, cpfcnpjMask } from "Helpers/Format";

export const downloadColumns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Nome",
    accessor: "full_name",
  },
  {
    Header: "E-mail",
    accessor: "email",
  },
  {
    Header: "CPF",
    accessor: (row) => (row.document ? cpfcnpjMask(row.document) : ""),
  },
  {
    Header: "Telefone",
    accessor: "phone",
  },
  {
    Header: "CEP",
    accessor: "cep",
  },
  {
    Header: "Endereço",
    accessor: "street",
  },
  {
    Header: "Número",
    accessor: "number",
  },
  {
    Header: "Complemento",
    accessor: "complement",
  },
  {
    Header: "Bairro",
    accessor: "neighborhood",
  },
  {
    Header: "Cidade",
    accessor: "city",
  },
  {
    Header: "UF",
    accessor: "uf",
  },
  {
    Header: "Opt-In",
    accessor: "opt_in",
  },
  {
    Header: "Data de Opt-In",
    accessor: (row) => (row.opt_in_date ? toDateTime(row.opt_in_date) : ""),
  },
  {
    Header: "Tipo",
    accessor: (row) => row.profile_type,
  },
  {
    Header: "Empresa",
    accessor: (row) => row.company_name ?? "—",
  },
  {
    Header: "Data de Inativação",
    accessor: (row) =>
      row.inactivated_at ? toDateTime(row.inactivated_at) : "",
  },
  {
    Header: "Último Login",
    accessor: (row) => (row.last_login ? toDateTime(row.last_login) : ""),
  },
  {
    Header: "Data de Criação",
    accessor: (row) => (row.created_at ? toDateTime(row.created_at) : ""),
  },
];

export const columns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Nome",
    accessor: "full_name",
  },
  {
    Header: "E-mail",
    accessor: "email",
  },
  {
    Header: "CPF",
    accessor: (row) => (row.document ? cpfcnpjMask(row.document) : ""),
  },
  {
    Header: "Telefone",
    accessor: "phone",
  },
  {
    Header: "Opt-In",
    accessor: "opt_in",
  },
  {
    Header: "Data de Opt-In",
    accessor: (row) => (row.opt_in_date ? toDateTime(row.opt_in_date) : ""),
  },
  {
    Header: "Canais",
    accessor: (row) => row.websites ?? "N/A",
  },
  {
    Header: "Tipo",
    accessor: (row) => row.profile_type,
  },
  {
    Header: "Empresa",
    accessor: (row) => row.company_name ?? "—",
  },
  {
    Header: "Data de Inativação",
    accessor: (row) =>
      row.inactivated_at ? toDateTime(row.inactivated_at) : "",
  },
];
